import { ButtonBasic, TextareaDynamicPlaceholder } from '@lk-gtcom/ecomlab-components';
import { useState, useRef, DragEvent, ChangeEvent } from "react"
import * as XLSX from 'xlsx'
import { parse } from 'papaparse'
import { ModalComponent } from '../../../ModalComponent/ModalComponent';
import './ModalCsv.scss'

interface ModalCsvProps {
  setIsModal: (value: boolean) => void
  setFilterValue: (value: string[]) => void
  initialFilterValue?: string[]
  [key: string]: any
}

const ModalCsv = ({
  ...props
}: ModalCsvProps) => {
  const { setIsModal, setFilterValue, initialFilterValue = [] } = props
  const [filterTextValue, setFilterTextValue] = useState<string | string[]>(initialFilterValue.join('\n') || '')
  const [isHover, setIsHover] = useState(false)
  const fileInput = useRef<HTMLInputElement>(null)

  const handleTextareaChange = (e: string | string[]) => {
    if (Array.isArray(e)) {
      setFilterTextValue(e.join('\n'))
    } else {
      setFilterTextValue(e)
    }
  }

  const saveValue = () => {
    if (Array.isArray(filterTextValue)) {
      setFilterValue(filterTextValue)
    } else {
      const valuesArray = filterTextValue.split('\n').filter(item => item.trim() !== '')
      setFilterValue(valuesArray)
    }
  }

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setIsHover(true)
  }

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setIsHover(false)
  }

  const handleFiles = (files?: FileList | null) => {
    if (!files) return

    Array.from(files).forEach(async (file) => {
      const isCSV = file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv')

      if (isCSV) {
        const text = await file.text()
        const res = (parse(text, { header: true })?.data as Record<string, any>[])
          ?.map(el => Object.values(el).join(''))
          .filter(el => el.trim() !== '')

        setFilterTextValue(res.join('\n'))
      } else {
        const reader = new FileReader()
        reader.readAsBinaryString(file)
        reader.onload = (evt) => {
          /* Parse data */
          const bstr = evt.target?.result as string
          const wb = XLSX.read(bstr, { type: 'binary' })
          /* Get first worksheet */
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          /* Convert worksheet to rows */
          const data = XLSX.utils.sheet_to_csv(ws).split(/\n/).filter(el => el !== '')
          /* Skip header row, update state */
          const res = data.slice(1)
          setFilterTextValue(res.join('\n'))
        }
        reader.onerror = () => console.log(reader.error)
      }
    })
  }

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setIsHover(false)
    handleFiles(e.dataTransfer?.files)
  }

  const handleFileInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleFiles(e.target.files)
    e.target.value = ''
  }

  const isTextEmpty = Array.isArray(filterTextValue)
    ? filterTextValue.length === 0
    : filterTextValue.trim() === ''

  return (
    <ModalComponent
      title='Фильтр по артикулу'
      onClose={(e: any) => setIsModal(false)}
      style={{ maxWidth: '600px', height: 'auto' }}
      child={
        <div
          className='modal-filter-article__content'
          onDragEnter={handleDragEnter}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <TextareaDynamicPlaceholder
            placeholder='Введите значение артикулов для фильтра через красную строку'
            returnArr={false}
            width={'100%'}
            onChange={handleTextareaChange}
            changeValue={filterTextValue}
          />

          {isTextEmpty ? (
            <div
              className={!isHover ? 'modal-filter-article__drop-container' : 'modal-filter-article__drop-container dragover'}
              onClick={() => fileInput.current?.click()}
            >
              <input
                type='file'
                style={{ opacity: 0, visibility: 'hidden', position: 'absolute', zIndex: -1000 }}
                ref={fileInput}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFileInputChange}
              />
              или перетащите файл Excel или CSV
            </div>
          ) : null}

          <ButtonBasic
            green
            text='Применить'
            onClick={() => {
              saveValue()
              setIsModal(false)
            }}
          />
        </div>
      }
    />
  )
}

export { ModalCsv }
